import React, { Fragment } from "react";
import { CheckBoxInput } from "../../../Buttons";
import { FaTimes } from "react-icons/fa";

function RowsInShipmentService({
  handleCheckBoxOrdersSelected,
  selectedOrderRows,
  order_rows,
}) {
  const renderCheckBox = (id) => {
    const findItem = selectedOrderRows.find((som) => som.id == id);
    if (findItem?.isUsed && findItem?.selected == false) {
      return (
        <div className="d-block">
          <label
            className="ant-checkbox-wrapper cursor-pointer"
            onClick={() => handleCheckBoxOrdersSelected(id)}
          >
            <span className="ant-checkbox" style={{ top: 0 }}>
              <span className="ant-checkbox-inner d-flex justify-content-center align-items-center">
                <FaTimes color="#ff9e00" />
              </span>
            </span>
          </label>
        </div>
      );
    }
    return (
      <CheckBoxInput
        checked={findItem?.selected ? true : false}
        onChange={() => handleCheckBoxOrdersSelected(id)}
      />
    );
  };
  return (
    <Fragment>
      <span style={{ fontWeight: "400" }}>
        <table className="table table-sm">
          <tbody>
            {order_rows.map((e) => (
              <tr key={e.id}>
                <td className="align-middle text-center">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: 32 }}
                  >
                    {renderCheckBox(e.id)}
                  </div>
                </td>
                <td className="align-middle text-center">
                  <div>
                    {e.amount
                      ? Math.floor(e.amount)
                      : e?.quantity
                        ? Math.floor(e?.quantity)
                        : 0}*
                  </div>
                </td>
                <td className="align-middle">
                  <div>{e.product_name}</div>
                </td>
                <td className="align-middle text-center">
                  <span style={{ whiteSpace: "nowrap" }}>
                    {Number(e.unit_price_tax_incl).toFixed(2) || 0} &#8364;
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </span>
    </Fragment>
  );
}

export default RowsInShipmentService;